import { useEffect, useSyncExternalStore } from 'react';

import { useEsCodexFlag } from './EsFlags';

// What a public page says about itself, for the tab and for the meta description. One slot,
// held outside React so EsPageTitle (in the shell, above every route) can read what a page
// below it set, and so a page leaving puts the shell's own title back.
let current = null;
const listeners = new Set();

const publish = ( pMeta ) => {
    current = pMeta;
    listeners.forEach( ( pListener ) => pListener() );
};

const subscribe = ( pListener ) => {
    listeners.add( pListener );
    return () => listeners.delete( pListener );
};

export const useEsPageMetaValue = () => useSyncExternalStore( subscribe, () => current );

/**
 * A public page names itself: the tab reads "<title> - Escapade" and the meta description is
 * the text given -- for a codex entry or a pack, the description esback sends with it
 * (EsSeoService.describe), the same words its server HTML carries. Nothing happens until there
 * is a title, and on unmount the shell's own title returns. Behind rolloutEsCodex, as the
 * server half is.
 */
export const useEsPageMeta = ( pTitle, pDescription ) => {
    const aOn = useEsCodexFlag();

    useEffect( () => {
        if ( !aOn || !pTitle ) return undefined;

        const aMeta = { title: pTitle, description: pDescription || '' };
        publish( aMeta );
        return () => {
            if ( current === aMeta ) publish( null );
        };
    }, [ aOn, pTitle, pDescription ] );
};
